import { useEffect, useRef, useState } from "react";

import { useLocation } from "react-router-dom";

import { transactionService } from "../services/transactionService";
import { partnerService } from "../services/partnerService";

export const useCancelCallModal = ({
  handleCancelCallConfirm,
  isTytoModalOpened,
  isConsentModalOpened,
  isMTLBenefitModalOpened,
}: {
  handleCancelCallConfirm: () => Promise<void>;
  isTytoModalOpened: boolean;
  isConsentModalOpened: boolean;
  isMTLBenefitModalOpened: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const location = useLocation();

  // Clear any existing timeout
  const clearExistingTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Start 2-minute countdown
  const startCountdown = () => {
    clearExistingTimeout();
    timeoutRef.current = setTimeout(() => {
      showCancelCallModal();
    }, 1000 * 120); // 2 minutes
  };

  const showCancelCallModal = () => {
    const partner = partnerService.getPartner();

    // Ensure pathname check is correct
    if (location.pathname !== "/call") return;

    // If partner has appointment, don't show
    if (partner && partner.appointmentCode) return;

    // If any other modal is open, retry after 60 seconds (legacy parity)
    if (isTytoModalOpened || isConsentModalOpened || isMTLBenefitModalOpened) {
      timeoutRef.current = setTimeout(showCancelCallModal, 1000 * 60);
      return;
    }

    setIsVisible(true);
  };

  const hideCancelCallModal = () => {
    setIsVisible(false);
    startCountdown(); // Restart the 2-minute countdown
  };

  useEffect(() => {
    startCountdown(); // Start initial countdown

    return () => {
      clearExistingTimeout();
    };
  }, []);

  // not used for now
  const handleBack = async () => {
    await transactionService.cancelQueue();
    window.location.href = "/confirm";
  };

  return {
    isVisible,
    showCancelCallModal,
    hideCancelCallModal,
    handleCancelCallConfirm,
    handleBack,
  };
};
